import { Component } from '@angular/core';

@Component({
    selector: '<not-found></not-found>',
    template: `<h1 class="text-center text-danger">Sorry, Page Not Found</h1>`
})
export class NotFoundComponent { }